import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { authGuard, contextGuard, flowSkinGuard } from './app.guards';
import { CallbackComponent } from './pages/callback/callback.component';
import { FlowComponent } from './pages/flow/flow.component';
import { UnauthorizedComponent } from './pages/unauthorized/unauthorized.component';

const routes: Routes = [
  {
    path: '',
    canActivate: [contextGuard],
    children: [
      {
        path: 'flow',
        component: FlowComponent,
        canActivate: [authGuard, flowSkinGuard],
      },
      {
        path: 'flow/tw',
        canActivate: [authGuard],
        loadChildren: () => import('./skins/tailwind/tailwind-skin.module').then((m) => m.TailwindSkinModule),
      },
      {
        path: 'flow/ibc',
        canActivate: [authGuard],
        loadChildren: () => import('./skins/indy/indy-skin.module').then((m) => m.IndySkinModule),
      },
      {
        path: 'flow/dev',
        canActivate: [authGuard],
        loadChildren: () => import('./skins/dev/dev-skin.module').then((m) => m.DevSkinModule),
      },
      {
        path: 'callback',
        component: CallbackComponent,
      },
      {
        path: 'callback/:event',
        component: CallbackComponent,
      },
      // {
      //   path: 'CallbackWithPostMessage',
      //   component: CallbackComponent,
      // },
      {
        path: 'unauthorized',
        component: UnauthorizedComponent,
      },
      {
        path: '**',
        redirectTo: 'flow',
      },
    ],
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      enableTracing: false,
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
